import { navRouterMap } from "@/router";
import Cookies from "js-cookie";
import axios from "../api/index";
import _ from "lodash";

const filterImSessionList = (list) => {
  return new Promise(async (resolve, reject) => {
    // let arr = [];
    // arr = list.filter(item => {
    //   return !item.lastMessage.messageForShow;
    // });
    // if (!arr.length) {
    //   resolve(list);
    //   return;
    // }
    let arrId = list.map((item) => item.toAccount);
    try {
      let res = await axios.filiterFeedbackList({ ids: arrId });
      for (let item of res.data) {
        for (let obj of list) {
          if (item._id === obj.toAccount) {
            obj.remark = item.remark || "";
            if (!obj.lastMessage.messageForShow) {
              obj.lastMessage.messageForShow = item.CustomMsgData;
              obj.lastMessage.lastTime = new Date(item.MsgTime).valueOf();
            }
            continue;
          }
        }
      }
      resolve(list);
    } catch (error) {
      reject(error);
    }
  });
};
const mutations = {
  windowHandle: (state, value) => {
    state.popup.appModal = true;
    switch (value) {
      case "addPopup":
        state.popup.addPopup = true;
        break;
      case "addChannelPopup":
        state.popup.addChannelPopup = true;
        break;
      case "addPopupImg":
        state.popup.addPopupImg = true;
        break;
      case "addBooks":
        state.popup.addBooks = true;
        break;
      case "addRootNodeBooks":
        state.popup.addRootNodeBooks = true;
        break;
      case "addEditRootNodeBooks":
        state.popup.addEditRootNodeBooks = true;
        break;
      case "delPopup":
        state.popup.delPopup = true;
        break;
      case "showAddBooksList":
        state.popup.showAddBooksList = true;
        break;
      case "showRefreshBooksList":
        state.popup.showRefreshBooksList = true;
        break;
      case "delFacility":
        state.popup.delFacility = true;
        break;
      case "appendPopup":
        state.popup.appendPopup = true;
        break;
      case "macPopup":
        state.popup.macPopup = true;
        break;
      case "showCreateOrg":
        state.popup.showCreateOrg = true;
        break;
      case "showPushChannel":
        state.popup.showPushChannel = true;
        break;
      case "showDateTimePicker":
        state.popup.showDateTimePicker = true;
        break;
      case "showAddBookList":
        state.popup.showAddBookList = true;
        break;
      case "showBatchUpload":
        state.popup.showBatchUpload = true;
        break;
      case "showClassifyEdit":
        state.popup.showClassifyEdit = true;
        break;
      case "showClassifyEditBoobsLis":
        state.popup.showClassifyEditBoobsLis = true;
        break;
      default:
        for (let item in state.popup) {
          state.popup[item] = false;
        }
    }
  },
  setBuckets: (state, buckets) => {
    state.buckets = buckets;
  },
  setBucketData: (state, bucketData) => {
    state.bucketData = bucketData;
  },
  SAVE_CATEGORIES: (state, data) => {
    state.categories = data;
  },
  SAVE_CHANNELS: (state, data) => {
    state.channels = data.rows;
  },
  navCtrl: (state) => {
    state.navCtrl = !state.navCtrl;
  },
  USER_INFO: (state, data) => {
    state.userInfo = data;
  },
  SAVE_HAS_DATA: (state, data) => {
    state.hasData = data;
  },

  SET_ROUTER: (state, data) => {
    state.userRouters = data;
    if (data.length === 0) return;
    state.routers = navRouterMap.filter((item) => data.includes(item.meta.key));
    // 后端返回的模块列表；为了兼容未下发的新模块，这里增加本地补充
    // const extraModules = ["starNote学院"];
    // const merged = Array.from(new Set([...(data || []), ...extraModules]));
    // state.userRouters = merged;
    // if (merged.length === 0) return;
    // state.routers = navRouterMap.filter((item) => merged.includes(item.meta.key));
  },
  CLEAR_ROUTER: (state) => {
    state.routers = [];
  },
  SET_SELECT_SHOW: (state, val) => {
    state.selectShow = val;
    // console.error('val----:', val)
  },
  SET_OVERALL_SHOW: (state, show) => {
    state.isSelectOverall = show;
  },
  SET_HANDLE_SHOW: (state, handle) => {
    state.isHandle = handle;
  },
  SET_LANG: (state, lang) => {
    state.language = lang;
    Cookies.set("language", lang);
  },
  SET_MSG_LIST: (state, msg) => {
    let obj = JSON.parse(JSON.stringify(msg));
    obj.payload.text = JSON.parse(JSON.parse(JSON.stringify(obj.payload.text)));
    state.imMsgList = [...state.imMsgList, obj];
  },
  UPDATE_MSG_LIST: (state, list) => {
    for (let item of list) {
      try {
        let msg = JSON.parse(JSON.parse(JSON.stringify(item.payload.text)));
        item.payload.text = msg;
        if (!item.msgKey || typeof item.msgKey === "undefined") {
          item.msgKey = `${item.sequence}_${item.random}_${item.time}`;
        }
      } catch (error) {
        continue;
      }
    }
    state.imMsgList = list;
  },
  UPDATE_SESSION_LIST: async (state, list) => {
    let listArr = await filterImSessionList(list);
    for (let item of listArr) {
      if (typeof item.lastMessage.messageForShow === "string") {
        try {
          let msg = JSON.parse(
            JSON.parse(JSON.stringify(item.lastMessage.messageForShow))
          );
          msg.desc = !item.lastMessage.isRevoked
            ? msg.desc
            : "你撤回了一条消息";
          item.lastMessage.messageForShow = msg;
        } catch (error) {
          console.log(error);
        }
      } else {
        let msg = item.lastMessage.messageForShow;
        msg.desc = !item.lastMessage.isRevoked ? msg.desc : "你撤回了一条消息";
        item.lastMessage.messageForShow = msg;
      }
    }
    state.imSessionList = listArr;
  },
  CTRL_ITEM: (state, item) => {
    state.ctrlItem = item;
  },

  // ============= cb信息反馈 ============
  MERGE_CB_MSG_LIST: (state, arr) => {
    let list = [...state.cbMsgList, ...arr];
    state.cbMsgList = _.orderBy(_.uniqBy(list, "uniqueId"), ["createdAt"]);
    console.log("pzz--MERGE_CB_MSG_LIST", state.cbMsgList);
  },
  UPDATE_CB_MSG_LIST: (state, list) => {
    state.cbMsgList = _.orderBy(_.uniqBy(list, "uniqueId"), ["createdAt"]);
    console.log("pzz--UPDATE_CB_MSG_LIST", state.cbMsgList);
  },
  UPDATE_CB_USER_LIST: (state, list) => {
    state.cbUserList = list;
  },

  SET_CB_CURRENT_USER: (state, item) => {
    state.cbCurrentUser = item;
  },
};

export default mutations;
